import {API_BASE_URL, STORAGE_KEYS} from '@/shared/config'

interface StartRecordingResponse {
  call_id: string
  egress_id: string
}

function getToken(): string | null {
  return localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN)
}

async function request<T>(
  path: string,
  options: RequestInit & {token?: string | null} = {},
): Promise<T> {
  const {token = getToken(), ...init} = options
  const headers = new Headers(init.headers as HeadersInit)
  headers.set('Content-Type', 'application/json')
  if (token) headers.set('Authorization', `Bearer ${token}`)

  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...init,
    headers,
    credentials: 'include',
  })

  if (!res.ok) {
    const body = await res.text()
    let apiMessage = body
    try {
      const j = JSON.parse(body)
      if (j.error) apiMessage = j.error
      else if (j.message) apiMessage = j.message
    } catch {
      apiMessage = body || `HTTP ${res.status}`
    }
    const err = new Error(apiMessage || `Ошибка при записи звонка (${res.status})`)
    ;(err as Error & {status?: number}).status = res.status
    throw err
  }

  if (res.status === 204) return undefined as T
  return res.json() as Promise<T>
}

export async function startRecording(roomId: string): Promise<StartRecordingResponse> {
  return request<StartRecordingResponse>('/recordings/start', {
    method: 'POST',
    body: JSON.stringify({room_id: roomId}),
  })
}

export async function stopRecording(egressId: string): Promise<void> {
  return request<void>('/recordings/stop', {
    method: 'POST',
    body: JSON.stringify({egress_id: egressId}),
  })
}
